export interface IValueTextPair<T> {
  text: string;
  value: T;
  extension?: any;
  ext2?:any;
  ext3?:any;
  ext4?:any;
}

export class ValueTextPair implements IValueTextPair<string> {
  text: string;
  value: string;
  extension?: any;
  ext2?:any;
  ext3?:any;
  ext4?:any;
  static fromNumberValue(array: ValueTextPairNumberValue[]): ValueTextPair[] {
    return array.map(item => {
      let dic = new ValueTextPair();
      dic.text = item.text;
      dic.value = item.value.toString();
      dic.extension = item.extension;
      dic.ext2 = item.ext2;
      dic.ext3 = item.ext3;
      dic.ext4 = item.ext4;
      return dic;
    });
  }
}

export class ValueTextPairNumberValue implements IValueTextPair<number> {
  text: string;
  value: number;
  extension?: any;
  ext2?:any;
  ext3?:any;
  ext4?:any;
}

export interface DoctorOption extends IValueTextPair<number> {
  IsEnabled?: boolean;
  LeaveDate?: Date | string;
}

export class ValueTextPairAnyValue {
  text: string;
  value: any;
  extension?: any;
}
export class ValueTextPairT<T> extends ValueTextPairAnyValue {
  value: T;
}
